module.exports = "/_next/static/images/anniu-335a92bde2c07ddae6bd25e3631bf5e6.png";